import { groupForecasterRoutes } from '@groupForecaster/routes';
import { priceOptimizerRoutes } from '@priceOptimizer/routes';
import { menuEngineeringRoutes } from '@menuEngineering/routes';
import OptimizerView from './views/OptimizerView.vue';
import Optimizer from './Optimizer.vue';

export const optimizerRoutes = [
  {
    path: 'optimizer/:periodGuid',
    component: Optimizer,
    children: [
      ...groupForecasterRoutes,
      ...priceOptimizerRoutes,
      ...menuEngineeringRoutes,
      { path: '', component: OptimizerView, name: 'optimizer' }
    ]
  }
];
